// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class Float implements flatbuffers.IUnpackableObject<FloatT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Float {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFloat(bb: flatbuffers.ByteBuffer, obj?: Float): Float {
    return (obj || new Float()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFloat(bb: flatbuffers.ByteBuffer, obj?: Float): Float {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Float()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
  }

  static startFloat(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldFloat32(0, value, 0.0);
  }

  static endFloat(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createFloat(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    Float.startFloat(builder);
    Float.addValue(builder, value);
    return Float.endFloat(builder);
  }

  unpack(): FloatT {
    return new FloatT(this.value());
  }

  unpackTo(_o: FloatT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): FloatT {
    const t = new FloatT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class FloatT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0.0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return Float.createFloat(builder, this.value);
  }

  clone(): FloatT {
    const obj = new FloatT();
    obj.value = this.value;
    return obj;
  }

  equals(other: FloatT): boolean {
    if (!Object.is(this.value, other.value)) return false;
    return true;
  }
}

export function verifyFloat(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
